var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Tabs from 'bootstrap/js/dist/tab';
export class Tabs extends Component {
    constructor(isDebugEnabled = false) {
        super('Collapse', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('#platform-tabs button').each((button) => {
                const tabTrigger = new BS_Tabs(button.get(0));
                button.on('click', (event) => {
                    event.preventDefault();
                    tabTrigger.show();
                });
            });
            $('[data-platform-selector] button').on('click', (event, button) => {
                // Show/hide xs introduction texts
                $('.tutorial-video-xs-introduction').addClass('d-none');
                $(`#tutorial-video-xs-introduction-${button.data('platform')}`).removeClass('d-none');
                // Show/hide platform texts
                $('.platforms-text').addClass('d-none');
                $(`.platforms-text[data-platform="${button.data('platform')}"]`).removeClass('d-none');
                // Stop and reset video when switching tabs
                $('#platform-tabs-content .tab-pane .tutorial-video-video').each((video) => {
                    if (video.get(0)) {
                        video.get(0).pause();
                        video.get(0).currentTime = 0;
                    }
                });
            });
            this.success();
        });
    }
}
